import EtchVideo from './EtchVideo.component';

export default EtchVideo;
